export const preloadImage = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
    img.src = src;
  });
};

export const preloadImages = async (srcs: string[]): Promise<void> => {
  try {
    await Promise.all(srcs.map((src) => preloadImage(src)));
  } catch (error) {
    throw error;
  }
};

export const preloadVideo = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'auto';
    
    video.addEventListener('canplaythrough', () => resolve(), { once: true });
    video.addEventListener('error', () => reject(new Error(`Failed to load video: ${src}`)), { once: true });
    
    video.src = src;
    video.load();
  });
};

export const preloadVideos = async (srcs: string[]): Promise<void> => {
  try {
    await Promise.all(srcs.map((src) => preloadVideo(src)));
  } catch (error) {
    throw error;
  }
};

export const preloadFont = async (fontName: string, fontUrl: string): Promise<void> => {
  try {
    const fontFace = new FontFace(fontName, `url(${fontUrl})`);
    await fontFace.load();
    (document.fonts as FontFaceSet & { add: (font: FontFace) => void }).add(fontFace);
  } catch (error) {
    throw new Error(`Failed to load font: ${fontName}`);
  }
};

export const preloadFonts = async (fonts: Array<{ name: string; url: string }>): Promise<void> => {
  try {
    await Promise.all(fonts.map((font) => preloadFont(font.name, font.url)));
  } catch (error) {
    throw error;
  }
};
